<!--
   - This is the login page for the application. It allows users to sign in using their email address.
   - The form is simple and only requires an email address. The backend will handle the authentication
   - and will return an error if the email address is not valid or does not exist in the database.
   - The page also includes a link to go back to the "Today" page, which is the main dashboard of
   - the application.
   -->

<div class="login-page">
  <h1>Sign in</h1>
  <p class="hint">
    Use an email that exists in the backend (dev seed: <code class="text-code">test&#64;lumen.local</code>). Enter a
    password only if the account was created with one.
  </p>

  <div *ngIf="error()" class="lm-error-text">{{ error() }}</div>

  <form (ngSubmit)="submit()" class="login-form">
    <div class="form-group">
      <label for="email">Email</label>
      <input
        id="email"
        name="email"
        type="email"
        autocomplete="username"
        [(ngModel)]="email"
        [disabled]="loading()"
      />
    </div>
    <div class="form-group">
      <label for="password">Password (optional)</label>
      <input
        id="password"
        name="password"
        type="password"
        autocomplete="current-password"
        [(ngModel)]="password"
        [disabled]="loading()"
      />
    </div>
    <button type="submit" class="lm-btn lm-btn--primary" [disabled]="loading()">
      {{ loading() ? 'Signing in…' : 'Sign in' }}
    </button>
  </form>
</div>
